import { AnyAction } from 'redux';
import { GlobalActions, VorversicherungChanged, } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';

export const vorversicherungReducer = function(
  sectionState: boolean = null,
  action: AnyAction,
  state: IAppState,
): boolean {
  if (action.type === GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED) {
    const actionPayload: VorversicherungChanged = action.payload;
    const { appId, angebotsId } = actionPayload;
    if (appId === App.VWG_V2 && angebotsId === state.angebotsId) {
      return actionPayload.vorhanden;
    }
  }
  return sectionState;
};
